import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from './analytics';

export const bootstrap = new BootstrapBrowserBuilder('zillow-rental-manager-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({
    logPath: '/rental-manager/log',
    level: 'warn',
  })
  .withDatadogPlugin('8a5708c6-c0fa-44d9-9bdd-435624427dd5', 'pub46805c78013bc26da7b518383eddffe3')
  .withOnRegister(analytics.initialize)
  .build();
